export const refreshHistory = (
    module: string,
    recordId: number | string
) => {
    window.dispatchEvent(
        new CustomEvent("history-refresh", {
            detail: {
                module,
                recordId,
            },
        })
    );
};